export const findById = (dataList: [], id: string) => dataList.find((item: any) => id === item.id);

export default {
  findById,
};
